export default __webpack_public_path__ + "static/media/abin.a8c652f5.png";